module.exports = __webpack_public_path__ + "img/gift4-01-c01-t1.8480c5cd.png";